import React from 'react';
import { useInView } from 'react-intersection-observer';

import IntroB from '../Reponsywne/LewyObiektPelny';
import ObAnimated from '../Zanimowane/Animated';
import Obrazek from '../Zanimowane/Obrazek';

export default function SekcjaDwa() {

    const { ref, inView } = useInView();
    const variants = {
        hidden: { x: '300%' },
        visible: { x: 0 },
    };


    return (

        <div className='flex justify-between' ref={ref}>
            <div>
                <ObAnimated referencja={inView} czyZanimowane={true}>
                    <IntroB tytul={"Projects"} fontSize={85} refer={inView} button={true} czyZanimowane={true} link={"/portfolio/projects"}>
                        <p className={'text-[34px] absolute'}>Summary of projects I have worked on.</p>
                    </IntroB>
                </ObAnimated>
            </div>

            <div>
                <Obrazek referencja={inView} urlObrazka={"fala1.jpg"}/>
            </div>
        </div>

    )

}